import { connect } from 'react-redux'
import { layoutActions } from '@Techedge/digitalportal-shared'
import Header from '../components/Layout/Header/Header'
import MainContent from '../components/Layout/MainContent/MainContent'
import { LuxBreadcrumb } from '@lux/wardrobe-lib'
import './NewActivity.scss'
import './Grsd.scss'

interface GrsdProps {
    grsdToken: string
    grsdParams: string
    closeGrsd: () => void
    onCloseGrsd?: () => void
}

const Grsd = ({ grsdToken, grsdParams, closeGrsd, onCloseGrsd }: GrsdProps) => {
    const componentClass = 'smart-modals-new-activity'

    const onClose = () => {
        onCloseGrsd && onCloseGrsd()
        !onCloseGrsd && closeGrsd()
    }

    return (
        <div className="smart-modals-fullscreen">
            <div className={componentClass} data-isfullscreen={true}>
                <div className={`${componentClass}__header`}>
                    <Header onClose={onClose} isFullScreen>
                        <LuxBreadcrumb pathArray={[]} />
                    </Header>
                </div>
                <div className={`${componentClass}__main`}>
                    <div className={`${componentClass}__content grsd`}>
                        <MainContent hideFooter>
                            <iframe
                                src={`${process.env.GRSD_URL}?code=${grsdToken}${grsdParams || ''}`}
                                width="100%"
                                height="100%"
                            />
                        </MainContent>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    grsdToken: state.layoutReducer.modals.props?.grsdToken,
    grsdParams: state.layoutReducer.modals.props?.grsdParams,
})

const mapDispatchToProps = (dispatch: any) => ({
    closeGrsd: () => {
        dispatch(
            layoutActions.setModals({
                type: null,
                props: {
                    id: null,
                    isEdit: false,
                    isClone: false,
                    grsdToken: null,
                    grsdParams: null,
                },
            })
        )
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(Grsd)
